export default __webpack_public_path__ + "static/media/Hamburger.2e963829.svg";